export const appleLink = 'https://apps.apple.com/us/app/aika-play-grow/id6745216707';
export const googleLink = 'https://play.google.com/store/apps/details?id=com.umaylab.aika';
